import { useContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { AppContext } from '../context/app';
import {
  isGozioPlace,
  isLatLng,
  isSatellitePlace,
  isSearchAddressResult,
} from '../utils/typeGuards';
import { useKioskManager } from './useKioskManager';

export const useNavStartingPlaceLabel = (): string => {
  const { navStartingPlace, isUsingCurrentLocation } = useContext(AppContext);
  const { kioskRegistration, kioskLocationLoading, kioskSite } =
    useKioskManager();

  const { t } = useTranslation('common');
  const startingPlaceLabel = useMemo(() => {
    if (!navStartingPlace || !!kioskLocationLoading) {
      return '';
    }

    if (isSearchAddressResult(navStartingPlace)) {
      return navStartingPlace.address;
    } else if (
      isGozioPlace(navStartingPlace) &&
      'name' in navStartingPlace &&
      navStartingPlace.name
    ) {
      return navStartingPlace.name;
    } else if (isLatLng(navStartingPlace)) {
      if (isUsingCurrentLocation) {
        return t('campusNavigation.location.currentLocation');
      }
      return `${navStartingPlace.lat},${navStartingPlace.lng}`;
    } else if (kioskRegistration && kioskSite) {
      return `${kioskSite?.short_name || kioskSite?.name} Kiosk`;
    } else if (isSatellitePlace(navStartingPlace)) {
      return navStartingPlace.name;
    }
    return '';
  }, [
    isUsingCurrentLocation,
    kioskLocationLoading,
    kioskRegistration,
    kioskSite,
    navStartingPlace,
    t,
  ]);
  return startingPlaceLabel;
};
